import React from 'react';
import UserAuditDownloadModal from './UserAuditDownloadModal';
import UserAuditTable from './UserAuditTable';
import RadioGroup from '../../../reusable/Form/RadioGroup';
import { FormattedMessage } from 'react-intl';
import FileDownload from './FileDownload';

let dateFormat = require('dateformat');

export default class UserAuditDownloadModalWrapper extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalLoading:    false,
            userSelectionType: "all_users",
            selectedUserIds:   [],
            startDownload: false,
            formDataPayload: []
        };

        this.isLoadingHandler = this.isLoadingHandler.bind(this);
        this.setUserSelectionType = this.setUserSelectionType.bind(this);
        this.startDownload = this.startDownload.bind(this);
        this.updateUserSelection = this.updateUserSelection.bind(this);
        this.onDownloadComplete = this.onDownloadComplete.bind(this);
    }

    isLoadingHandler(param) {
        this.setState({isModalLoading: param})
    }

    setUserSelectionType(event) {
        const selectionType = event.target.value;
        if (selectionType === "all_users") {
            this.setState({userSelectionType: selectionType, selectedUserIds: []});
        } else {
            this.setState({userSelectionType: selectionType});
        }

    }

    updateUserSelection(selectedUserIds) {
        this.setState({selectedUserIds});
    }

    startDownload(event) {
        let date = new Date();
        let uiDate = dateFormat(date, "dd mmm yyyy");
        let uiTime = dateFormat(date, "HH:MM");

        let formDataPayload = {
            selectAllUsers:  this.state.userSelectionType === "all_users" ? true : false,
            selectedUserIds: this.state.userSelectionType === "specific_users" ? this.state.selectedUserIds : [],
            uiDate,
            uiTime
        };

        this.setState({formDataPayload,startDownload: true});
    }

    onDownloadComplete() {
        this.setState({startDownload: false});
        this.props.secondaryAction();
    }

    radioOptions = [
        {
            value: 'all_users',
            label: <FormattedMessage id="UserAudit_Download_UIText_modalOptions.all" />
        },
        {
            value:   'specific_users',
            label:   <FormattedMessage id="UserAudit_Download_UIText_modalOptions.specific" />,
        }
    ];

    render = () =>
        <UserAuditDownloadModal modalName={'ModalDownloadUserAudit__' + this.state.userSelectionType}
                                isModalLoading={this.state.isModalLoading}
                                isPrimaryButtonDisabled={this.state.userSelectionType === 'specific_users' && this.state.selectedUserIds.length === 0}
                                primaryI18n={"UserAudit_Download_UIText_modalActions.download"}
                                primaryAction={this.startDownload}
                                secondaryI18n={"UserAudit_Download_UIText_modalActions.cancel"}
                                secondaryAction={this.props.secondaryAction}
                                title={"UserAudit_Download_UIText_modalTitle"}>
            <div className="download-instructions"><FormattedMessage id="UserAudit_Download_UIText_instructions" /></div>
            <RadioGroup value={this.state.userSelectionType} fieldId={"users-selector"} onChange={this.setUserSelectionType} options={this.radioOptions} classNames="notranslate"/>
            {this.state.userSelectionType === 'specific_users' && <UserAuditTable isLoadingHandler={this.isLoadingHandler} onUpdateSelection={this.updateUserSelection}/>}
            {this.state.startDownload &&
            <FileDownload
                queryParams={this.state.formDataPayload}
                actionPath={"/api/audit/download/user-audit"}
                onDownloadComplete={this.onDownloadComplete}
            />
            }
        </UserAuditDownloadModal>;
}



// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/UserAuditDownloadModalWrapper.jsx